export var truncateAddress = function (address) {
    return address.slice(0, 6) + "..." + address.slice(address.length - 4);
};
//# sourceMappingURL=address.js.map